// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","name":"Logo_name___3SnP","phase":"Logo_phase__1IVkj"};